import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, FieldArray, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {Badge, Button, ButtonToolbar, Card, Col, Form, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {RadioField, scrollToErrors, TextField} from '../form/form';
import {Acl} from "../../utils";

const partyTypeOptions = [
	{value: 'PERSON', label: 'FO'},
	{value: 'COMPANY', label: 'PO'}
];

const yesNoOptions = [
	{value: true, label: <i className={'fa fa-check'}/>},
	{value: false, label: <i className={'fa fa-times'}/>}
];

const yesNullOptions = [
	{value: true, label: <i className={'fa fa-check'}/>},
	{value: null, label: <i className={'fa fa-times'}/>}
];

const vatPeriodOptions = [
	{value: 'MONTH', label: '1'},
	{value: 'QUARTER', label: '3'}
];

const validate = (values, b, c) => {
	const errors = {};
	if (!values.title) {
		errors.title = 'Zadejte prosím popis'
	}
	if (!values.abbr) {
		errors.abbr = 'Zadejte prosím zkratku'
	}
	if (!values.partyType) {
		errors.partyType = 'Vyberte prosím typ'
	}
	if (!values.isVat && values.isVat !== false) {
		errors.isVat = 'Vyberte prosím DPH'
	}

	const accountsErrors = {};
	if (!values.accounts || !values.accounts.length) {
		// allow empty
	} else {
		for (let i = 0; i < values.accounts.length; i++) {
			const item = values.accounts[i];
			const itemErrors = {};
			if (!item.accountNo) {
				itemErrors.accountNo = 'Zadejte prosím číslo účtu';
			}

			if (Object.keys(itemErrors).length) {
				accountsErrors[i] = itemErrors;
			}
		}
	}

	if (Object.keys(accountsErrors).length) {
		errors.accounts = accountsErrors;
	}

	return errors
};

class PartyForm extends Component {

	constructor(props) {
		super(props);

		this.renderPartyAccounts = this.renderPartyAccounts.bind(this);
		this.renderPartners = this.renderPartners.bind(this);
	}

	renderPartyAccounts({fields, meta: {error, submitFailed}}) {
		const {change} = this.props;
		return <div>
			{fields.map((member, index) => (
				<Row key={index}>
					<Col md={2}>
						<Row>
							<Col md={6}>
								<Button size={"sm"} variant={"warning"} title={fields.get(index).accountId} onClick={() => {
									const newAccounts = [];
									for (let i = 0; i < fields.length; i++) {
										if (i === index) {
											continue;
										}
										const newItem = fields.get(i);
										newAccounts.push(newItem)
									}
									change('accounts', newAccounts);
								}}><i className={"fa fa-times"}/> </Button>
							</Col>
						</Row>
					</Col>
					<Col md={6}>
						<Field label='Číslo' name={`${member}.accountNo`} type='text' component={TextField} maxLength="30" sizes={[0, 12]}/>
					</Col>
					<Col md={4}>
						<Field label='Typ' name={`${member}.type`} type='text' component={TextField} maxLength="30" sizes={[0, 12]}/>
					</Col>
				</Row>
			))}
			<Row key={'new'}>
				<Col md={1}>
					<Row>
						<Col md={6}>
							<Button size={"sm"} variant={"info"} title="Přidat účet" onClick={() => {
								fields.push({});
							}}><i className={"fa fa-plus"}/> </Button>
						</Col>
					</Row>
				</Col>
				{error ? <Col md={11}>
					<div className={"text-danger"}>{error}</div>
				</Col> : null}
			</Row>
		</div>
	}

	renderPartners({fields, meta: {error, submitFailed}}) {
		const {change} = this.props;
		return <Col xs={12}>
			{fields.map((member, index) => (
				<Row key={index}>
					<Col md={2}>
						<Row>
							<Col md={6}>
								<Button size={"sm"} variant={"warning"} onClick={() => {
									const newAccounts = [];
									for (let i = 0; i < fields.length; i++) {
										if (i === index) {
											continue;
										}
										const newItem = fields.get(i);
										newAccounts.push(newItem)
									}
									change('extra.partners', newAccounts);
								}}><i className={"fa fa-times"}/> </Button>
							</Col>
						</Row>
					</Col>
					<Col md={6}>
						<Field label='Partner' name={`${member}.partyAbbr`} type='text' component={TextField} maxLength="30" sizes={[0, 12]}/>
					</Col>
					<Col md={4} className={"text-right"}>
						<Field label="Výchozí" name={`${member}.isPrimary`} options={yesNullOptions} component={RadioField} sizes={[5, 7]}/>
					</Col>
				</Row>
			))}
			<Row key={'new'}>
				<Col md={1}>
					<Row>
						<Col md={6}>
							<Button size={"sm"} variant={"info"} title="Přidat partnera" onClick={() => {
								fields.push({});
							}}><i className={"fa fa-plus"}/> </Button>
						</Col>
					</Row>
				</Col>
				{error ? <Col md={11}>
					<div className={"text-danger"}>{error}</div>
				</Col> : null}
			</Row>
		</Col>
	}

	render() {
		const {
			handleSubmit, initialValues, submitting,
			onSaveParty, onDeleteParty,
			formState
		} = this.props;

		const isTracked = formState && formState.values && formState.values.isTracked;

		return (
			<Form noValidate onSubmit={handleSubmit((values) => {
				return onSaveParty(values)
			})} className={"detail"}>
				<Row>
					<Col lg={6}>
						<Row>
							<Col xs={12}>
								<Card>
									<Card.Header>Subjekt {initialValues.abbr}
										{initialValues.partyId ? <Badge variant={"dark"} className="pull-right">ID {initialValues.partyId}</Badge> : null}</Card.Header>
									<Card.Body>
										<Row>
											<Col xs={12}>
												<Field label='Název' required name="title" type='text' component={TextField} maxLength="200" sizes={[2, 10]}/>
											</Col>
										</Row>
										<Row>
											<Col xs={6}>
												<Field label="Zkratka" name="abbr" type='text' component={TextField} maxLength="50"/>
											</Col>
											<Col xs={6}>
												<Field label="Typ" name="partyType" options={partyTypeOptions} component={RadioField}/>
											</Col>
										</Row>
										<Row>
											<Col xs={6}>
												<Field label={"IČ"} name="companyNumber" type='text' component={TextField} maxLength="10" sizes={[4, 8]}/>
											</Col>
											<Col xs={6}>
												<Field label={"DIČ"} name="taxNumber" type='text' component={TextField} maxLength="20" sizes={[4, 8]}/>
											</Col>
										</Row>
										<Row>
											<Col xs={6}>
												<Field label="DPH" name="isVat" options={yesNoOptions} component={RadioField}/>
											</Col>
										</Row>
									</Card.Body>
								</Card>
							</Col>
						</Row>
						<Row>
							<Col xs={12}>
								<Card>
									<Card.Header>Účty</Card.Header>
									<Card.Body className={"form-items"}>
										<FieldArray name={"accounts"} component={this.renderPartyAccounts}/>
									</Card.Body>
								</Card>
							</Col>
						</Row>
					</Col>
					<Col lg={6}>
						<Card>
							<Card.Header>Detail</Card.Header>
							<Card.Body>
								<Row>
									<Col xs={8}>
										<Field label={"Email"} name="email" type='text' component={TextField} maxLength="50" sizes={[3, 9]}/>
									</Col>
									<Col xs={4} className={"text-right"}>
										<Field label="Faktury" name="isMailInvoice" options={yesNoOptions} component={RadioField} sizes={[5, 7]}/>
									</Col>
								</Row>
								<Row className={'divider'}>
									<Col xs={6}>
										<Field label="Sledovat" name="isTracked" options={yesNoOptions} component={RadioField}/>
									</Col>
									{isTracked ? <Col xs={{offset: 2, span: 4}} className={"text-right"}>
										<Field label="Období" title={'DPH období'} name="extra.vatPeriod" options={vatPeriodOptions} component={RadioField} sizes={[5, 7]}/>
									</Col> : null}
								</Row>
								<Row>
									<Col xs={12}>
										{isTracked ?
											<Row className={'form-items divider'}>
												<FieldArray name={"extra.partners"} component={this.renderPartners}/>
											</Row>
											: <Field label={'Partner'} name="extra.defaultPartAbbr" type="text" component={TextField} sizes={[2, 4]}/>}
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<ButtonToolbar className="text-center">
							<Link to={{pathname: "/parties"}} className="btn btn-link"> Storno</Link>
							{Acl.hasAction(initialValues, Acl.party.DELETE) &&
							<Button variant="danger" type="button" disabled={submitting} onClick={() => onDeleteParty(initialValues)}><span className="fa fa-trash"/> Smazat</Button>}
							<Button variant="success" type="submit" disabled={submitting}><span className="fa fa-ok"/> {initialValues.partyId ? "Uložit změny" : "Založit subjekt"}</Button>
						</ButtonToolbar>
					</Col>
				</Row>
			</Form>
		)
	}
}

PartyForm.propTypes = {
	id: PropTypes.number,
	item: PropTypes.object.isRequired,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onSaveParty: PropTypes.func.isRequired,
	onDeleteParty: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

PartyForm = reduxForm({
	form: 'party',
	validate,
	onSubmitFail: scrollToErrors
})(PartyForm);

const mapStateToProps = (state, ownProps) => ({
	formState: state.form.party,
});

export default connect(mapStateToProps)(PartyForm)
